import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import Loading from '../components/Loading';
import './Projects.css';

const Projects = () => {
  const { projects, categories, getProjectsByCategory, loading } = useData();
  const [selectedCategory, setSelectedCategory] = useState('');

  // Filter projects based on selected category
  const filteredProjects = useMemo(() => {
    if (loading) return [];
    return getProjectsByCategory(selectedCategory);
  }, [loading, selectedCategory, getProjectsByCategory]);

  return (
    <div className="projects-page">
      <section className="page-header">
        <div className="container">
          <h1>Proiectele Noastre</h1>
          <p>Descoperă colecția noastră completă de proiecte de design</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* Category Filter */}
          <div className="filter-section">
            <button
              className={`filter-btn ${selectedCategory === '' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('')}
            >
              Toate Proiectele
            </button>
            {categories.map(category => (
              <button
                key={category.id}
                className={`filter-btn ${selectedCategory === category.slug ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.slug)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          {loading ? (
            <Loading />
          ) : filteredProjects.length > 0 ? (
            <div className="grid grid-3">
              {filteredProjects.map(project => (
                <Link to={`/projects/${project.slug}`} key={project.id} className="project-card card">
                  {project.featured_image && (
                    <img src={project.featured_image} alt={project.title} />
                  )}
                  <div className="card-content">
                    <h3>{project.title}</h3>
                    <p className="category">{project.category_name}</p>
                    {project.size && <p className="size">Dimensiune: {project.size}</p>}
                    <p className="description">{project.description.substring(0, 100)}...</p>
                    {project.show_price && project.price && (
                      <div className="price-section">
                        {project.discount_percentage && (
                          <span className="discount">-{project.discount_percentage}%</span>
                        )}
                        <div>
                          {project.original_price && (
                            <span className="original-price">{project.original_price} lei</span>
                          )}
                          <span className="price">{project.price} lei</span>
                        </div>
                      </div>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="no-data">Nu au fost găsite proiecte pentru această categorie.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default Projects;

